export default __webpack_public_path__ + "assets/images/4.719bf8.webp";